<script setup lang="ts">
import { useToast } from '~/composables/toast'

// グローバルな toast 表示。app.vue に1つだけ設置し、useToast().show() で表示する。
const { message, visible } = useToast()
</script>

<template>
  <div class="c-toast" :class="{ 'c-toast--show': visible }" role="status" aria-live="polite">
    {{ message }}
  </div>
</template>

<style scoped lang="scss">
@use '~/styles/bonatitan/mixins' as m;

.c-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: var(--c-text);
  color: var(--c-white);
  padding: 10px 20px;
  border-radius: 50px;
  font-size: var(--f-size-sm);
  font-weight: 700;
  z-index: 300;
  opacity: 0;
  transition: opacity 0.3s;
  white-space: nowrap;
  pointer-events: none;

  &--show {
    opacity: 1;
  }
}

// モバイルは下部タブバー(fixed-footer, bottom:0・約72px)が表示されるため、既定の 24px だと
// トーストがバーに被って読めない。バーの逃げ(body padding-bottom:72px)+余白ぶん上へ表示する。
@include m.media-down('mobile') {
  .c-toast {
    bottom: calc(72px + 16px);
  }
}
</style>
